<template>
  <div class="logout-btn-wrap">
    <button type="button" class="logout-btn" @click='logoutUser'>
      <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M1.0914e-06 18.6667C1.06435e-06 19.2855 0.245835 19.879 0.683419 20.3166C1.121 20.7542 1.7145 21 2.33333 21L18.6667 21C19.2855 21 19.879 20.7542 20.3166 20.3166C20.7542 19.879 21 19.2855 21 18.6667L21 2.33333C21 1.71449 20.7542 1.121 20.3166 0.683417C19.879 0.245832 19.2855 -7.4943e-08 18.6667 -1.01993e-07L2.33334 -8.15946e-07C1.7145 -8.42996e-07 1.121 0.245832 0.68342 0.683416C0.245836 1.121 1.83241e-06 1.71449 1.80536e-06 2.33333L1.0914e-06 18.6667ZM10.5 9.33333L21 9.33333L21 11.6667L10.5 11.6667L10.5 16.3333L4.66667 10.5L10.5 4.66667L10.5 9.33333Z" fill="#858585"/>
      </svg>
      <p>Logout</p>
    </button>
  </div>
</template>

<script>
import { firebase } from '@firebase/app';
import router from '@/router/index.js';

export default {
  name: 'logout-button',
  methods: {
    logoutUser() {
      firebase.auth().signOut();
      router.push('/')
    }
  }
}
</script>

<style lang="scss">
  .logout-btn-wrap {
    button {
      width: 100%;
      padding: 27px 0 27px 40px;
      border: none;
      background: none;
      display: flex;

      &:focus {
        outline: none;
      }

      svg {
        margin-right: 20px;
      }

      p {
        color: #858585;
        margin: 0;
      }
    }
  }
</style>